import { UPDATE_CATEGORIES } from "../actions/category-action-types";
import { LOGOUT_SUCCESS } from "../actions/session-action-types";

const initialState = {
  categories: [],
};
export default function(state = initialState, { payload, type }) {
  switch (type) {
    case UPDATE_CATEGORIES:
      return {
        ...state,
        categories: payload,
      };
    case LOGOUT_SUCCESS:
      console.log("Initial State on logout", initialState);
      return { ...initialState };

    default:
      return state;
  }
}
